export default __webpack_public_path__ + "static/media/david2.638b1df6.jpg";